import React, { useRef, useEffect, useReducer, useMemo, useCallback, createContext } from 'react'
import { C, Page } from 'xadmin-ui'
import _ from 'lodash'
import { use, app, api } from 'xadmin'
import moment from 'moment'

const ceilNum = (d, prex) => {
  if (parseInt(d) == d) return d;
  let len = 1;
  let i = 0;
  while (parseInt(d) != d) {
    d = d * 10;
    len *= 10;
    i++;
  }
  let last = Math.abs(i <= prex ? 0 : d % (Math.pow(10, (i - prex))));
  let d1 = d - last;
  if (last > 0) {
    d1 = d1 + Math.pow(10, (i - prex));
  }
  d1 = d1 / len;
  return d1;
}

// const sliceNum = (number, fixed) => {
//   return Number(String(number).slice(0, String(number).indexOf('.') + fixed + 1))
// }

const sliceNum = (number, fixed) => {
  let str = String(number).split('.');
  if (str[1]?.length < fixed) {
    str[1] = (str[1] + '0'.repeat(fixed)).slice(0, fixed);
  } else {
    str[1] = str[1]?.slice(0, fixed);
  }
  return str.join('.')
}

const toFixed = (Dight, How = 2, polish) => {
  const v = Math.round(Dight * Math.pow(10, How)) / Math.pow(10, How)
  const pv = v => {
    const n = v.toString().split('.')
    if (n.length == 1) {
      return v + `${How > 0 ? '.' + _.padEnd('', How, '0') : ''}`
    } else {
      const decimal = n[1]
      return v + _.padEnd('', How - decimal.length, '0')
    }
  }
  return _.isNaN(v) ? Dight : polish ? pv(v) : v
}


const valueFormat = (val, fixed, valFormat, polish) => {
  if (valFormat == 'slice') {
    return _.isNumber(val) && _.isNumber(fixed) ? sliceNum(val, fixed) : val
  } else if (valFormat == 'carryUp') {
    return _.isNumber(val) ? ceilNum(val, fixed) : val
  } else {
    return toFixed(val, fixed, polish)
  }
}

const DataTagContext = createContext({})

const useInterval = (callback, delay) => {
  const savedCallback = useRef()

  useEffect(() => {
    savedCallback.current = callback
  });

  useEffect(() => {
    const tick = () => {
      savedCallback.current()
    }
    if (delay !== null) {
      let id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}

const DataTagProvider = ({ uids, interval, children }) => {

  const [state, dispatch] = useReducer((state, action) => {
    if (action.type == 'INIT') {
      return action.payload
    } else if (action.type == 'UPDATE') {
      return { ...state, ...action.payload }
    }
    return state
  }, {})

  const queue = useRef({})
  const { subscribe, onData, onStatus } = use('ws')

  const update = () => {
    if (queue.current && !_.isEmpty(queue.current)) {
      dispatch({ type: 'UPDATE', payload: queue.current })
      queue.current = {}
    }
  }
  useInterval(update, interval || 800)

  // mount 时挂载订阅数据
  React.useEffect(() => {
    onData(data => {
      if (data && _.isPlainObject(data)) {
        const nodeId = data.nodeId
        const fields = data.fields
        const time = data.time
        Object.keys(fields).forEach(tagId => {
          queue.current[`${nodeId}|${tagId}`] = { value: fields[tagId], time: time }
        })
      }
    })
    onStatus(status => {
      // console.log(status)
    })
  }, [])

  // 每次 items 变化要重新获取历史数据，重新订阅
  React.useEffect(() => {
    if (uids && uids.length > 0) {
      const query = uids.map(id => ({ allTag: true, id }))
      api({ name: 'core/data' })
        .fetch('/latest', { method: 'POST', body: JSON.stringify(query) })
        .then(({ json }) => {
          const payload = {}
          json.forEach(({ tagId, time, id, value }) => {
            payload[`${id}|${tagId}`] = { value, time: time }
          })
          dispatch({ type: 'INIT', payload })
        })
      return subscribe('data', query)
    }
  }, uids)
  return <DataTagContext.Provider value={state}>{children}</DataTagContext.Provider>
}


const DefaultDataTag = ({ value }) => value.value || '-'

const DataTag = props => {
  const { node, tag, tagProp } = props
  const data = React.useContext(DataTagContext)
  const rawValue = _.get(data, `${node.id || node.uid}|${tag.id}`)

  return useMemo(() => {
    const DataTagCompoent = C('DataTagPopover') || DefaultDataTag
    let value = rawValue

    if (tagProp && tagProp !== 'value') {
      if (tagProp === 'time') {
        value = {
          value: value && value[tagProp] ? moment(value[tagProp]).format('YYYY-MM-DD HH:mm:ss') : null,
          originValue: value?.value,
        }
      } else {
        value = {
          value: value && value[tagProp],
          originValue: value?.value,
        }
      }
    }

    // 数据点配置时间戳时间格式
    if (tag?.timeFormat?.hasFormat && tag?.timeFormat?.format && value?.value != undefined) {
      value = {
        ...rawValue,
        value: moment(value?.value).format(tag?.timeFormat?.format),
        originValue: value?.value,
      }
    }
    //  小数位数数据转换
    if (tag?.fixed) {
      value = {
        ...rawValue,
        value: valueFormat(value?.value, tag?.fixed, tag?.valFormat, tag?.polish),
        originValue: value?.value,
      }
    }

    return (
      <DataTagCompoent {...props}
        timeoutDisplay={true}
        value={value ?? <span className="text-muted">-</span>}
      />
    )
  }, [rawValue])

}

const TestDataTag = props => {
  return (<Page title="测试实时数据点">
    <DataTagProvider uids={['001']} interval={500}>
      <DataTag node={{ id: '001' }} tag={{ id: 'data2', name: '油温' }} />
    </DataTagProvider>
  </Page>)
}

export default {
  name: 'iot-datatag',
  components: {
    DataTagContext,
    DataTagProvider,
    DataTag
  },
  routers: {
    '/app/': [
      {
        path: 'test_datatag',
        component: TestDataTag
      }
    ]
  },
}

export {
  DataTagContext,
  DataTagProvider,
  DataTag,
  valueFormat
}
